document.addEventListener('DOMContentLoaded', () => {
	// Helper: get language from the PHP-injected element, then fallback
	const getLang = () => {
		const el = document.getElementById('pll-lang');
		if (el && el.dataset && el.dataset.lang) return el.dataset.lang;
		// fallback to <html lang="..."> or 'en'
		const htmlLang = (
			document.documentElement.getAttribute('lang') || ''
		).slice(0, 2);
		return htmlLang || 'en';
	};

	const lang = getLang();

	const textMap = {
		en: { default: 'Questions? Ask here', close: 'Close Chat' },
		fr: {
			default: 'Des questions? Parlez-nous',
			close: 'Fermer la discussion',
		},
	};
	const t = textMap[lang] || textMap.en;

	// Wait for Chatbase API to be ready
	const waitForChatbase = setInterval(() => {
		if (
			window.chatbase &&
			typeof window.chatbase.open === 'function' &&
			typeof window.chatbase.close === 'function'
		) {
			clearInterval(waitForChatbase);

			let isOpen = false; // shared state

			const toggleButtons = Array.from(
				document.querySelectorAll('.open-chatbase')
			);
			const openButtons = Array.from(
				document.querySelectorAll('.chatbase-trigger')
			);

			// Initialize toggle button labels
			toggleButtons.forEach((el) => (el.textContent = t.default));

			// Utility to sync labels on all toggle buttons
			const syncToggleLabels = () => {
				toggleButtons.forEach((el) => {
					el.textContent = isOpen ? t.close : t.default;
				});
			};

			// Toggle buttons: open/close + label swap
			toggleButtons.forEach((el) => {
				el.addEventListener('click', (e) => {
					e.preventDefault();
					if (isOpen) {
						window.chatbase.close();
						isOpen = false;
					} else {
						window.chatbase.open();
						isOpen = true;
					}
					syncToggleLabels();
				});
			});

			// Simple open buttons (Gutenberg): just open, no label changes needed
			openButtons.forEach((el) => {
				el.addEventListener('click', (e) => {
					e.preventDefault();
					window.chatbase.open();
					isOpen = true;
					syncToggleLabels(); // keep toggle buttons accurate
				});
			});
		}
	}, 300);
});
